import Vue from "vue";
import SelectAsync from "£lement/SelectAsync";
import ModalConditios from "~/components/editor/ModalConditios.vue";
export default (editor, config = {}) => {
    const tm = editor.TraitManager;

    tm.addType("custom_select", {
        templateInput: "",
        createInput({ trait }) {
            this.traitsName = trait.attributes.name;
            const vueInst = new Vue({
                render: (h) =>
                    h(SelectAsync, {
                        props: {
                            placeholder:
                                trait.attributes.placeholder ||
                                "-- Select an option --",
                            optionsValue: trait.attributes.optionsValue,
                            optionsLabel: trait.attributes.optionsLabel,
                            endpoint: trait.attributes.endpoint,
                            resetOption: true,
                            size: "sm",
                        },
                    }),
            }).$mount();
            const selectInst = vueInst.$children[0];
            selectInst.$on("change", (ev) => this.onChange(ev));
            this.selectInst = selectInst;
            return vueInst.$el;
        },

        onEvent({ component }) {
            const value = this.selectInst.getComponentValue() || null;
            if (value == null) {
                component.removeAttributes(this.traitsName);
            } else {
                component.addAttributes({ [this.traitsName]: value });
            }
        },

        onUpdate({ component }) {
            const value = component.getAttributes()[this.traitsName] || null;
            this.selectInst.setComponentValue(value);
        },
    });

    tm.addType("conditions_editor", {
        templateInput: "",
        createInput({ trait }) {
            this.traitsName = trait.attributes.name;

            const vueInst = new Vue({
                render: (h) =>
                    h(ModalConditios, {
                        props: {
                            btnText: trait.attributes.text,
                            btnFull: trait.attributes.full
                        },
                    }),
            }).$mount();

            const modalInst = vueInst.$children[0];
            modalInst.$on("save", (ev) => this.onChange(ev));
            this.modalInst = modalInst;
            return vueInst.$el;
        },

        onEvent({ component }) {
            const value = this.modalInst.getConditions() || null;
            if (value == null) {
                component.removeAttributes(this.traitsName);
            } else {
                const conditionsEncode = JSON.stringify(value);
                console.log({conditionsEncode})
                component.addAttributes({ [this.traitsName]: conditionsEncode });
            }
        },

        onUpdate({ component }) {
            const value = component.getAttributes()[this.traitsName] || null;
            const conditions = (new Function("return " + value + ";")());
            this.modalInst.setConditions(conditions);
        },
    });
};
